import { Grid } from '@abyss/web/ui/Grid';
import { Text } from '@abyss/web/ui/Text';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'usehooks-ts';

import { phoneOnly } from '../../../../common/ConstantsStyles';
import { PSXProgressBar } from '../../../../common/PSXProgressBar/PSXProgressBar';
import { StoreKeys } from '../../../../hooks/useStore/state';
import { useStore } from '../../../../hooks/useStore/useStore';
import { shouldUseGehaV2Styling } from '../../../../utils/gehaThemeUtils';
import { RatingReviewsPercentageSection } from './PatientReviews.styled';

type Props = {
  healthgradesReview: any;
};

export const PatientRatingReviewsPercentage = ({
  healthgradesReview,
}: Props) => {
  if (!healthgradesReview) return null;
  const {
    fiveStarCount=0,
    fourStarCount=0,
    threeStarCount=0,
    twoStarCount=0,
    oneStarCount=0,
} = healthgradesReview?.aggregatedSurvey || {};
  const totalRating =
    fiveStarCount +
    fourStarCount +
    threeStarCount +
    twoStarCount +
    oneStarCount;
  const getStarPercentage = (count: number, total: number) => (total > 0 ? Math.round((count / total) * 100) : 0);
  const fiveStarPercentage = getStarPercentage(fiveStarCount, totalRating);
  const fourStarPercentage = getStarPercentage(fourStarCount, totalRating);
  const threeStarPercentage = getStarPercentage(threeStarCount, totalRating);
  const twoStarPercentage = getStarPercentage(twoStarCount, totalRating);
  const oneStarPercentage = getStarPercentage(oneStarCount, totalRating);
  const isWidget = useStore(StoreKeys.IS_WIDGET);
  const mobileScreen = useMediaQuery(phoneOnly);

  const { t } = useTranslation();
  const stars = [
    { star: 5, percentage: fiveStarPercentage },
    { star: 4, percentage: fourStarPercentage },
    { star: 3, percentage: threeStarPercentage },
    { star: 2, percentage: twoStarPercentage },
    { star: 1, percentage: oneStarPercentage },
  ];
  const isGEHAV2 = shouldUseGehaV2Styling();
  const additionalIconCss = isGEHAV2 ? '#00172F' : '';

  return (
    <RatingReviewsPercentageSection
      alignItems="flex-start"
      justify="flex-start"
    >
      <Grid
        css={{
          flex: healthgradesReview.providerExperienceRating ? 'unset' : 1,
        }}
      >
        <Grid.Col
          span={
            isWidget
              ? '75%'
              : { xs: '100%', sm: '100%', md: '65%', lg: '55%', xl: '43%' }
          }
        >
          <ul>
            {stars.map((star) => (
              <li
                justify="space-between"
                key={star.star}
                style={{ marginBottom: '8px', display: 'flex' }}
              >
                <Text
                  color={additionalIconCss}
                  fontWeight="700"
                  size="sm"
                  style={{
                    width: mobileScreen ? '22%' : isWidget ? '18%' : '15%',
                  }}
                >
                  {star.star}{' '}
                  {t('PROVIDER_DETAILS.ABOUT_TAB.REVIEW_SECTION.stars')}
                </Text>
                <span
                  style={{
                    marginTop: '1px',
                    width: mobileScreen ? '70%' : isWidget ? '75%' : '78%',
                  }}
                >
                  <PSXProgressBar
                    ariaHidden={true}
                    fillColor="$secondary2"
                    progress={star.percentage}
                  />
                </span>
                <Text
                  color={additionalIconCss}
                  fontWeight="700"
                  size="sm"
                  style={{
                    width: '5%',
                    textAlign: 'right',
                  }}
                >
                  {star.percentage ? star.percentage : 0}%
                </Text>
              </li>
            ))}
          </ul>
        </Grid.Col>
      </Grid>
    </RatingReviewsPercentageSection>
  );
};
